var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5832 0.166748H0.416504V25.8334H15.5832V0.166748ZM7.99984 24.6667C7.0315 24.6667 6.24984 23.8851 6.24984 22.9167C6.24984 21.9484 7.0315 21.1667 7.99984 21.1667C8.96817 21.1667 9.74984 21.9484 9.74984 22.9167C9.74984 23.8851 8.96817 24.6667 7.99984 24.6667ZM13.2498 20.0001H2.74984V3.66675H13.2498V20.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon_mobile.e8cf62a13e5d484293e0c63440668de7.svg";
export { ForwardRef as ReactComponent };